export var ProjectTemplateSpaceEnumType = /*#__PURE__*/ function(ProjectTemplateSpaceEnumType) {
    ProjectTemplateSpaceEnumType["ProjectSpaceValue"] = "PROJECT_SPACE";
    ProjectTemplateSpaceEnumType["SpaceTabValue"] = "SPACE_TAB";
    return ProjectTemplateSpaceEnumType;
}({});
export var BudgetedHoursCalculationMode = /*#__PURE__*/ function(BudgetedHoursCalculationMode) {
    BudgetedHoursCalculationMode["Auto"] = "auto";
    BudgetedHoursCalculationMode["Manual"] = "manual";
    return BudgetedHoursCalculationMode;
}({});
export var InsertDirection = /*#__PURE__*/ function(InsertDirection) {
    InsertDirection[InsertDirection["Above"] = 0] = "Above";
    InsertDirection[InsertDirection["Below"] = 1] = "Below";
    return InsertDirection;
}({});
